import React from 'react';
import { createRoot } from 'react-dom';
import './index.css';
import App from './App';

createRoot(document.getElementById('root')).render(<App />);
// require('events').EventEmitter.defaultMaxListeners = 100; // or any number you think is appropriate
